import { Component, input, output } from '@angular/core';
import { ClIcon } from '@corelabs/angular/ui';
import { ChevronDown } from 'lucide';

@Component({
    selector: 'app-menu-header',
    templateUrl: './menu-header.component.html',
    styleUrls: ['./menu-header.component.css'],
    imports: [ClIcon],
})
export class MenuHeaderComponent {
    protected readonly icons = { ChevronDown };

    readonly label = input.required<string>();
    readonly collapsed = input(false);

    readonly toggleCollapse = output<void>();
}
